import Link from 'next/link';
import { memo, type ReactNode } from 'react';

import { AirIcon } from '@air/design-icons';
import { VisuallyHidden } from '@air/primitive-visually-hidden';

import { Routes } from '~/constants/routes';

export const RedirectToExternalContainer = memo(({ children }: { children: ReactNode }) => (
  <section className="relative flex size-full items-center justify-center ads:bg-subtle bg-gray-3 text-center">
    <div className="flex w-full flex-col bg-white p-6 shadow-xl md:w-[480px] md:rounded-12 dark:bg-black">
      <header className="m-0 box-border flex h-[70px] w-full min-w-0 flex-col items-center">
        <Link href={Routes.root}>
          <VisuallyHidden>Go back to landing page.</VisuallyHidden>
          <AirIcon className="ads:text-icon-emphasis text-gray-12" size={76} aria-hidden="true" />
        </Link>
      </header>
      <div className="flex flex-col items-center justify-center p-5">{children}</div>
    </div>
  </section>
));

RedirectToExternalContainer.displayName = 'RedirectToExternalContainer';
